import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { permissionGuard } from './guards/permission.guard';
import { developerGuard } from './guards/developer.guard';
import { portalGuard } from './guards/portal.guard';
import { portalDirectorsGuard } from './guards/portal-directors.guard';
import { customerRedirectGuard } from './guards/customer-redirect.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { ErrorComponent } from './components/error/error.component';
import { MainComponent } from './components/main/main.component';
import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { PortalLayoutComponent } from './components/portal-layout/portal-layout.component';
import { PortalHomeComponent } from './components/portal/portal-home/portal-home.component';
import { PortalDirectorsComponent } from './components/portal/portal-directors/portal-directors.component';
import { PortalDirectorViewComponent } from './components/portal/portal-director-view/portal-director-view.component';
import { DataStatisticsComponent } from './components/portal/data-statistics/data-statistics.component';
import { CompanyListComponent } from './components/companies/company-list/company-list.component';
import { UserListComponent } from './components/administration/user-list/user-list.component';
import { UserCreateComponent } from './components/administration/user-create/user-create.component';
import { UserEditComponent } from './components/administration/user-edit/user-edit.component';
import { CustomerListComponent } from './components/administration/customer-list/customer-list.component';
import { IndexListComponent } from './components/configuration/index-list/index-list.component';
import { CustomerCreateComponent } from './components/administration/customer-create/customer-create.component';
import { CustomerEditComponent } from './components/administration/customer-edit/customer-edit.component';
import { LoginAttemptListComponent } from './components/administration/login-attempt-list/login-attempt-list.component';
import { ActiveYearSettingsComponent } from './components/administration/active-year-settings/active-year-settings.component';
import { EntrySupervisionComponent } from './components/control-panel/entry-supervision/entry-supervision.component';
import { CheckCorporateGovernanceComponent } from './components/control-panel/check-corporate-governance/check-corporate-governance.component';
import { CheckFamilyStatusComponent } from './components/control-panel/check-family-status/check-family-status.component';
import { AutomaticCorrectionComponent } from './components/control-panel/automatic-correction/automatic-correction.component';
import { DivCheckComponent } from './components/control-panel/divcheck/divcheck.component';
import { CustomerReportCellsComponent } from './components/control-panel/customer-report-cells/customer-report-cells.component';
import { CurrencyListComponent } from './components/companies/currency-list/currency-list.component';
import { NationalityListComponent } from './components/companies/nationality-list/nationality-list.component';
import { StockExchangeListComponent } from './components/companies/stock-exchange-list/stock-exchange-list.component';
import { ProfessionListComponent } from './components/directors/profession-list/profession-list.component';
import { IndustryExpertiseListComponent } from './components/directors/industry-expertise-list/industry-expertise-list.component';
import { FinancialExpertiseListComponent } from './components/directors/financial-expertise-list/financial-expertise-list.component';
import { PoliticalPositionListComponent } from './components/directors/political-position-list/political-position-list.component';
import { HonorificTitleListComponent } from './components/directors/honorific-title-list/honorific-title-list.component';
import { QualificationListComponent } from './components/directors/qualification-list/qualification-list.component';
import { EducationFieldListComponent } from './components/directors/education-field-list/education-field-list.component';
import { JobPositionListComponent } from './components/directors/job-position-list/job-position-list.component';
import { AccountingStandardListComponent } from './components/audit/accounting-standard-list/accounting-standard-list.component';
import { AuditOpinionListComponent } from './components/audit/audit-opinion-list/audit-opinion-list.component';
import { AuditOpinionModifiedListComponent } from './components/audit/audit-opinion-modified-list/audit-opinion-modified-list.component';
import { AuditOpinionQualifiedOptionListComponent } from './components/audit/audit-opinion-qualified-option-list/audit-opinion-qualified-option-list.component';
import { AuditEmphasisOfMatterListComponent } from './components/audit/audit-emphasis-of-matter-list/audit-emphasis-of-matter-list.component';
import { AuditGoingConcernListComponent } from './components/audit/audit-going-concern-list/audit-going-concern-list.component';
import { AuditKeyMatterListComponent } from './components/audit/audit-key-matter-list/audit-key-matter-list.component';
import { AuditMaterialityListComponent } from './components/audit/audit-materiality-list/audit-materiality-list.component';
import { AuditFeeCategoryListComponent } from './components/audit/audit-fee-category-list/audit-fee-category-list.component';
import { AuditFirmListComponent } from './components/audit/audit-firm-list/audit-firm-list.component';
import { UniversityListComponent } from './components/directors/university-list/university-list.component';
import { CountryListComponent } from './components/companies/country-list/country-list.component';
import { StockCategoryListComponent } from './components/corporate-governance/stock-category-list/stock-category-list.component';
import { StockCoefficientListComponent } from './components/corporate-governance/stock-coefficient-list/stock-coefficient-list.component';
import { BoardMemberOccupationListComponent } from './components/corporate-governance/board-member-occupation-list/board-member-occupation-list.component';
import { FamilyCompanyStatusListComponent } from './components/family-firms/family-company-status-list/family-company-status-list.component';
import { FamilyGenerationListComponent } from './components/family-firms/family-generation-list/family-generation-list.component';
import { CompanyDeregistrationReasonListComponent } from './components/corporate-governance/company-deregistration-reason-list/company-deregistration-reason-list.component';
import { CeoTurnoverReasonListComponent } from './components/corporate-governance/ceo-turnover-reason-list/ceo-turnover-reason-list.component';
import { CompensationOccupationListComponent } from './components/compensation/compensation-occupation-list/compensation-occupation-list.component';
import { CompensationMultiplierListComponent } from './components/compensation/compensation-multiplier-list/compensation-multiplier-list.component';
import { ConsultantFirmListComponent } from './components/compensation/consultant-firm-list/consultant-firm-list.component';
import { CompensationStandardListComponent } from './components/compensation/compensation-standard-list/compensation-standard-list.component';
import { CsrStandardListComponent } from './components/csr/csr-standard-list/csr-standard-list.component';
import { CsrAssuranceProviderListComponent } from './components/csr/csr-assurance-provider-list/csr-assurance-provider-list.component';
import { CsrMeasurementUnitListComponent } from './components/csr/csr-measurement-unit-list/csr-measurement-unit-list.component';
import { CsrCountryCapitalizationListComponent } from './components/csr/csr-country-capitalization-list/csr-country-capitalization-list.component';
import { IndustryListComponent } from './components/configuration/industry-list/industry-list.component';
import { DirectorListComponent } from './components/directors/director-list/director-list.component';
import { VoteResultsCategoryListComponent } from './components/voting-results/vote-results-category-list/vote-results-category-list.component';
import { VoteResultsOptionListComponent } from './components/voting-results/vote-results-option-list/vote-results-option-list.component';
import { DirectorCreateComponent } from './components/directors/director-create/director-create.component';
import { DirectorEditComponent } from './components/directors/director-edit/director-edit.component';
import { WorkExperienceCompanyListComponent } from './components/directors/work-experience-company-list/work-experience-company-list.component';
import { LargeShareholderCategoryListComponent } from './components/large-shareholders/large-shareholder-category-list/large-shareholder-category-list.component';
import { LargeShareholderListComponent } from './components/large-shareholders/large-shareholder-list/large-shareholder-list.component';
import { LargeShareholderEditComponent } from './components/large-shareholders/large-shareholder-edit/large-shareholder-edit.component';
import { LargeShareholderCreateComponent } from './components/large-shareholders/large-shareholder-create/large-shareholder-create.component';
import { PyramidalShareholderListComponent } from './components/pyramidal-shareholders/pyramidal-shareholder-list/pyramidal-shareholder-list.component';
import { PyramidalShareholderCreateComponent } from './components/pyramidal-shareholders/pyramidal-shareholder-create/pyramidal-shareholder-create.component';
import { PyramidalShareholderEditComponent } from './components/pyramidal-shareholders/pyramidal-shareholder-edit/pyramidal-shareholder-edit.component';
import { ChangePasswordComponent } from './components/administration/change-password/change-password.component';
import { CompensationCategoryConfigurationComponent } from './components/compensation/compensation-category-configuration/compensation-category-configuration.component';
import { AuditSectionConfigurationComponent } from './components/audit/audit-section-configuration/audit-section-configuration.component';
import { CountrySetupComponent } from './components/companies/country-setup/country-setup.component';
import { CompanyCreateComponent } from './components/companies/company-create/company-create.component';
import { CompanyEditComponent } from './components/companies/company-edit/company-edit.component';
import { OpbCompanyListComponent } from './components/opb-companies/opb-company-list/opb-company-list.component';
import { OpbCompanyCreateComponent } from './components/opb-companies/opb-company-create/opb-company-create.component';
import { OpbCompanyEditComponent } from './components/opb-companies/opb-company-edit/opb-company-edit.component';
import { CompanyVoteProposalNameListComponent } from './components/voting-results/company-vote-proposal-name-list/company-vote-proposal-name-list.component';
import { CompanyVoteProposalNameCreateComponent } from './components/voting-results/company-vote-proposal-name-create/company-vote-proposal-name-create.component';
import { CompanyVoteProposalNameEditComponent } from './components/voting-results/company-vote-proposal-name-edit/company-vote-proposal-name-edit.component';
import { CompanyVoteResultListComponent } from './components/voting-results/company-vote-result-list/company-vote-result-list.component';
import { MessageListComponent } from './components/messages/message-list/message-list.component';
import { MessageViewComponent } from './components/messages/message-view/message-view.component';
import { AuditLogListComponent } from './components/administration/audit-log/audit-log-list/audit-log-list.component';
import { IssueListComponent } from './components/issues/issue-list/issue-list.component';
import { IssueCreateComponent } from './components/issues/issue-create/issue-create.component';
import { IssueDetailComponent } from './components/issues/issue-detail/issue-detail.component';
import { IssueCategoryListComponent } from './components/issues/issue-category-list/issue-category-list.component';

export const routes: Routes = [
  {
    path: 'forbidden',
    component: ForbiddenComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'portal',
    component: PortalLayoutComponent,
    canActivate: [authGuard, portalGuard],
    children: [
      { path: '', component: PortalHomeComponent },
      {
        path: 'directors',
        component: PortalDirectorsComponent,
        canActivate: [portalDirectorsGuard]
      },
      {
        path: 'directors/:id',
        component: PortalDirectorViewComponent,
        canActivate: [portalDirectorsGuard]
      },
      { path: 'statistics', component: DataStatisticsComponent },
      { path: 'change-password', component: ChangePasswordComponent }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
  {
    path: '',
    canActivate: [authGuard, customerRedirectGuard],
    component: MainComponent
  },
  {
    path: 'users',
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Administration', subsection: 'Users' },
    children: [
      { path: '', component: UserListComponent },
      { path: 'create', component: UserCreateComponent },
      { path: 'edit/:id', component: UserEditComponent }
    ]
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  },
  {
    path: 'login-attempts',
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Administration', subsection: 'Login Attempts' },
    children: [
      { path: '', component: LoginAttemptListComponent }
    ]
  },
  {
    // Reachable via the Control Panel entry and the company/user deep links — all developer-only.
    // Gated on the Keycloak `developer` realm role, not a DB business role.
    path: 'auditlog',
    component: AuditLogListComponent,
    canActivate: [authGuard, developerGuard]
  },
  {
    path: 'app-settings/active-year',
    component: ActiveYearSettingsComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Administration', subsection: 'App Settings' }
  },
  {
    path: 'issues',
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Issues', subsection: 'Issues List' },
    children: [
      { path: '', component: IssueListComponent },
      { path: 'create', component: IssueCreateComponent },
      { path: ':id', component: IssueDetailComponent }
    ]
  },
  {
    path: 'issue-categories',
    component: IssueCategoryListComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Issues', subsection: 'Categories' }
  },
  {
    path: 'session-reports',
    component: EntrySupervisionComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Control Panel', subsection: 'Entry Supervision' }
  },
  {
    path: 'check-corporate-governance',
    component: CheckCorporateGovernanceComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Control Panel', subsection: 'Check Corporate Governance' }
  },
  {
    path: 'check-family-status',
    component: CheckFamilyStatusComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Control Panel', subsection: 'Check Family' }
  },
  {
    path: 'automatic-correction',
    component: AutomaticCorrectionComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Control Panel', subsection: 'Automatic Correction' }
  },
  {
    path: 'divcheck',
    component: DivCheckComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Control Panel', subsection: 'Deviation Check' }
  },
  {
    path: 'customer-report-cells',
    component: CustomerReportCellsComponent,
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Control Panel', subsection: 'Customer Reports' }
  },
  {
    path: 'configuration',
    children: [
      {
        path: 'currencies',
        component: CurrencyListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Configuration', subsection: 'Currencies' }
      },
      {
        path: 'nationalities',
        component: NationalityListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Configuration', subsection: 'Nationalities' }
      },
      {
        path: 'stock-exchanges',
        component: StockExchangeListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Configuration', subsection: 'Stock Exchanges' }
      },
      {
        path: 'indices',
        component: IndexListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Indices' }
      },
      {
        path: 'industries',
        component: IndustryListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Industries' }
      }
    ]
  },
  {
    path: 'customers',
    canActivate: [authGuard, permissionGuard],
    data: { section: 'Administration', subsection: 'Customers' },
    children: [
      { path: '', component: CustomerListComponent },
      { path: 'create', component: CustomerCreateComponent },
      { path: 'edit/:id', component: CustomerEditComponent }
    ]
  },
  {
    path: 'companies',
    children: [
      {
        path: 'list',
        component: CompanyListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Companies List' }
      },
      {
        path: 'countries-setup',
        component: CountrySetupComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Countries Setup' }
      },
      {
        path: 'create',
        component: CompanyCreateComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Companies List' }
      },
      {
        path: 'edit/:id',
        component: CompanyEditComponent,
        canActivate: [authGuard, permissionGuard],
        canDeactivate: [unsavedChangesGuard],
        data: { section: 'Companies', subsection: 'Companies List' }
      },
      {
        path: 'opb-list',
        component: OpbCompanyListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Opb Companies List' }
      },
      {
        path: 'opb-create',
        component: OpbCompanyCreateComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Opb Companies List' }
      },
      {
        path: 'opb-edit/:id',
        component: OpbCompanyEditComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Companies', subsection: 'Opb Companies List' }
      },
    ]
  },
  {
    path: 'directors',
    children: [
      {
        path: 'list',
        component: DirectorListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Directors List' }
      },
      {
        path: 'create',
        component: DirectorCreateComponent,
        canActivate: [authGuard, permissionGuard],
        canDeactivate: [unsavedChangesGuard],
        data: { section: 'Directors', subsection: 'Directors List' }
      },
      {
        path: 'edit/:id',
        component: DirectorEditComponent,
        canActivate: [authGuard, permissionGuard],
        canDeactivate: [unsavedChangesGuard],
        data: { section: 'Directors', subsection: 'Directors List' }
      },
      {
        path: 'professions',
        component: ProfessionListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Professions' }
      },
      {
        path: 'industry-expertises',
        component: IndustryExpertiseListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Industry Expertise' }
      },
      {
        path: 'financial-expertises',
        component: FinancialExpertiseListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Financial Expertise' }
      },
      {
        path: 'political-positions',
        component: PoliticalPositionListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Political Positions' }
      },
      {
        path: 'honorific-titles',
        component: HonorificTitleListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Honorific Titles' }
      },
      {
        path: 'qualifications',
        component: QualificationListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Qualifications' }
      },
      {
        path: 'education-fields',
        component: EducationFieldListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Education Fields' }
      },
      {
        path: 'job-positions',
        component: JobPositionListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Job Positions' }
      },
      {
        path: 'work-experience-companies',
        component: WorkExperienceCompanyListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Work Experience Companies' }
      },
      {
        path: 'universities',
        component: UniversityListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Directors', subsection: 'Universities' }
      }
    ]
  },
  {
    path: 'audit',
    children: [
      {
        path: 'accounting-standards',
        component: AccountingStandardListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Accounting Standards' }
      },
      {
        path: 'audit-opinions',
        component: AuditOpinionListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Opinion' }
      },
      {
        path: 'audit-opinion-modifieds',
        component: AuditOpinionModifiedListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Opinion Modified' }
      },
      {
        path: 'audit-opinion-qualified-options',
        component: AuditOpinionQualifiedOptionListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Opinion Qualified' }
      },
      {
        path: 'audit-emphasis-of-matters',
        component: AuditEmphasisOfMatterListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Emphasis of Matters' }
      },
      {
        path: 'audit-going-concerns',
        component: AuditGoingConcernListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Going Concern' }
      },
      {
        path: 'audit-key-matters',
        component: AuditKeyMatterListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Key Audit Matters' }
      },
      {
        path: 'audit-materiality',
        component: AuditMaterialityListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Materiality' }
      },
      {
        path: 'audit-fee-categories',
        component: AuditFeeCategoryListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Audit Fees Categories' }
      },
      {
        path: 'audit-firms',
        component: AuditFirmListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Audit Firms' }
      },
      {
        path: 'audit-section-configuration',
        component: AuditSectionConfigurationComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Audit', subsection: 'Section Configuration' }
      }
    ]
  },
  {
    path: 'corporate-governance',
    children: [
      {
        path: 'stock-categories',
        component: StockCategoryListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Corporate Governance', subsection: 'Stock Categories' }
      },
      {
        path: 'stock-coefficients',
        component: StockCoefficientListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Corporate Governance', subsection: 'Stock Coefficients' }
      },
      {
        path: 'occupations',
        component: BoardMemberOccupationListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Corporate Governance', subsection: 'Occupations' }
      },
      {
        path: 'company-deregistration-reasons',
        component: CompanyDeregistrationReasonListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Corporate Governance', subsection: 'Deregistration Reasons' }
      },
      {
        path: 'ceo-turnover-reasons',
        component: CeoTurnoverReasonListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Corporate Governance', subsection: 'CEO Turnover Reasons' }
      }
    ]
  },
  {
    path: 'family-firms',
    children: [
      {
        path: 'family-company-statuses',
        component: FamilyCompanyStatusListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Family Firms', subsection: 'Family Company Statuses' }
      },
      {
        path: 'family-generations',
        component: FamilyGenerationListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Family Firms', subsection: 'Family Generations' }
      }
    ]
  },
  {
    path: 'compensation',
    children: [
      {
        path: 'occupations',
        component: CompensationOccupationListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Compensation', subsection: 'Occupations' }
      },
      {
        path: 'multipliers',
        component: CompensationMultiplierListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Compensation', subsection: 'Multiplier' }
      },
      {
        path: 'category-configuration',
        component: CompensationCategoryConfigurationComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Compensation', subsection: 'Category Configuration' }
      },
      {
        path: 'consultant-firms',
        component: ConsultantFirmListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Compensation', subsection: 'Consultant Firms' }
      },
      {
        path: 'standards',
        component: CompensationStandardListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Compensation', subsection: 'Standards' }
      }
    ]
  },
  {
    path: 'csr',
    children: [
      {
        path: 'standards',
        component: CsrStandardListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'ESG', subsection: 'Standards' }
      },
      {
        path: 'assurance-providers',
        component: CsrAssuranceProviderListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'ESG', subsection: 'Assurance Providers' }
      },
      {
        path: 'measurement-units',
        component: CsrMeasurementUnitListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'ESG', subsection: 'Measurement Units' }
      },
      {
        path: 'country-capitalization',
        component: CsrCountryCapitalizationListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'ESG', subsection: 'Country - Capitalization' }
      }
    ]
  },
  {
    path: 'voting-results',
    children: [
      {
        path: 'list',
        component: CompanyVoteResultListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Voting Results', subsection: 'Voting Results List' }
      },
      {
        path: 'categories',
        component: VoteResultsCategoryListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Voting Results', subsection: 'Categories' }
      },
      {
        path: 'options',
        component: VoteResultsOptionListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Voting Results', subsection: 'Options' }
      },
      {
        path: 'shareholder-proposal-names',
        children: [
          {
            path: 'list',
            component: CompanyVoteProposalNameListComponent,
            canActivate: [authGuard, permissionGuard],
            data: { section: 'Voting Results', subsection: 'Shareholder Proposal Names List' }
          },
          {
            path: 'create',
            component: CompanyVoteProposalNameCreateComponent,
            canActivate: [authGuard, permissionGuard],
            data: { section: 'Voting Results', subsection: 'Shareholder Proposal Names List' }
          },
          {
            path: 'edit/:id',
            component: CompanyVoteProposalNameEditComponent,
            canActivate: [authGuard, permissionGuard],
            data: { section: 'Voting Results', subsection: 'Shareholder Proposal Names List' }
          }
        ]
      }
    ]
  },
  {
    path: 'large-shareholders',
    children: [
      {
        path: 'list',
        component: LargeShareholderListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Large Shareholders', subsection: 'Large Shareholders List' }
      },
      {
        path: 'create',
        component: LargeShareholderCreateComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Large Shareholders', subsection: 'Large Shareholders List' }
      },
      {
        path: 'edit/:id',
        component: LargeShareholderEditComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Large Shareholders', subsection: 'Large Shareholders List' }
      },
      {
        path: 'categories',
        component: LargeShareholderCategoryListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Large Shareholders', subsection: 'Categories' }
      }
    ]
  },
  {
    path: 'pyramidal-shareholders',
    children: [
      {
        path: 'list',
        component: PyramidalShareholderListComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Large Shareholders', subsection: 'Pyramidal Shareholders List' }
      },
      {
        path: 'create',
        component: PyramidalShareholderCreateComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Large Shareholders', subsection: 'Pyramidal Shareholders List' }
      },
      {
        path: 'edit/:id',
        component: PyramidalShareholderEditComponent,
        canActivate: [authGuard, permissionGuard],
        data: { section: 'Large Shareholders', subsection: 'Pyramidal Shareholders List' }
      }
    ]
  },
  {
    path: 'messages',
    canActivate: [authGuard],
    data: { section: 'Messages', subsection: 'Messages' },
    children: [
      { path: '', component: MessageListComponent },
      { path: ':id', component: MessageViewComponent }
    ]
  }
    ]
  }
];
